module.exports = __webpack_public_path__ + "img/google-wallet-h5-clean.242e4c8f.png";